import { Sparkles, Users, ShieldCheck, HeartHandshake } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { SectionLabel, GoldButton } from "@/components/ui-kit";
import { PageHero } from "@/components/blocks";
import { images } from "@/data/site";

const points = [
  { icon: Sparkles, title: "Corsi bambini in arrivo", text: "Percorsi dedicati all'infanzia in fase di definizione, pensati con cura e attenzione." },
  { icon: ShieldCheck, title: "Probabile percorso Karate", text: "Una disciplina orientata a disciplina, rispetto, coordinazione e autocontrollo." },
  { icon: Users, title: "Attività per bambini e famiglie", text: "Momenti di movimento condiviso, per crescere insieme in modo sano ed educativo." },
  { icon: HeartHandshake, title: "Formula Family disponibile", text: "Una soluzione pensata per vivere la palestra insieme, adulti e bambini." },
];

export default function KidsFamily() {
  return (
    <>
      <Seo title="Kids & Family a Lusciano | Body Evolution 2.0" description="Kids & Family di Body Evolution 2.0: percorsi per bambini e famiglie, tra movimento, coordinazione, disciplina e crescita." />
      <PageHero label="Kids & Family" title="Kids & Family: il movimento diventa crescita" image={images.kidsFamily}
        text="Body Evolution 2.0 dedica attenzione anche ai più piccoli, con percorsi pensati per avvicinare bambini e ragazzi al movimento in modo sano, educativo e coinvolgente. I corsi dedicati all'infanzia sono in fase di definizione e saranno orientati allo sviluppo di coordinazione, disciplina, fiducia, socializzazione e benessere." />

      <section className="bg-sand py-24 lg:py-32">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
          <Reveal><SectionLabel>In definizione</SectionLabel></Reveal>
          <div className="mt-12 grid sm:grid-cols-2 gap-6">
            {points.map((p, i) => (
              <Reveal key={p.title} delay={(i % 2) * 0.08}>
                <div className="lift h-full bg-white border border-black/10 rounded-sm p-8 hover:border-gold">
                  <p.icon className="text-gold" size={28} strokeWidth={1.5} />
                  <h3 className="mt-5 font-display text-xl font-medium text-ink-800">{p.title}</h3>
                  <p className="mt-3 text-ink-800/60 text-sm leading-relaxed">{p.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-6 justify-between bg-white border border-black/10 rounded-sm p-8">
              <p className="text-ink-800/70 max-w-xl">I dettagli sui corsi bambini sono in aggiornamento. Contattaci per essere tra i primi a ricevere informazioni.</p>
              <GoldButton to="/contatti" className="shrink-0">Richiedi informazioni sui corsi bambini</GoldButton>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
